import * as z from "zod";
import { useForm } from "react-hook-form";
import { useLogin } from "../hooks/useLogin";
import { Input } from "../../../components/ui/Input";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "../../../components/ui/Button";
import { toast } from "sonner";

const loginSchema = z.object({
  username: z
    .string()
    .min(3, "نام کاربری حداقل باید ۳ کاراکتر باشد")
    .regex(
      /^[A-Za-z0-9_]+$/,
      "نام کاربری فقط می‌تواند شامل حروف انگلیسی، عدد و _ باشد"
    ),

  password: z
    .string()
    .min(6, "رمز عبور حداقل باید ۶ کاراکتر باشد")
    .regex(
      /^[\x20-\x7E]+$/,
      "رمز عبور فقط می‌تواند شامل حروف انگلیسی و کاراکترهای مجاز باشد"
    ),
});

type LoginFormValues = z.infer<typeof loginSchema>;

export default function LoginForm() {
  const { login, loading } = useLogin();

  const { register, handleSubmit } = useForm<LoginFormValues>({
    resolver: zodResolver(loginSchema),
  });

  const onError = (errors: any) => {
    const firstError = Object.values(errors)[0] as any;
    if (firstError?.message) {
      toast.error(firstError.message);
    }
  };

  const onSubmit = async (data: LoginFormValues) => {
    try {
      await login(data.username, data.password);
    } catch { }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit, onError)}
      className="space-y-5 mx-7"
    >
      <div className="space-y-2">
        <Input
          className="!shadow-md"
          type="text"
          placeholder="نام کاربری"
          lang="en"
          {...register("username")}
        />

        <Input
          className="!shadow-md"
          type="password"
          placeholder="رمز عبور"
          lang="en"
          {...register("password")}
        />
      </div>

      <div className="w-full h-[3.125rem] flex items-center justify-end gap-x-5 text-base">
        <button
          type="button"
          className="h-full text-white text-nowrap text-[13px] font-normal hover:underline"
        >
          بازیابی کلمه عبور
        </button>

        <Button type="submit" disabled={loading} className="basis-28 text-base font-normal !h-full">
          {loading ? (
            <span className="size-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
          ) : (
            "ورود"
          )}
        </Button>
      </div>
    </form>
  );
}
